import {ReactNode} from 'react'
import RHT, {Toast} from 'react-hot-toast'
import {StyledCloseIcon, StyledToastContainer} from './style'

const renderToast = (content: ReactNode, id: string, variant: 'success' | 'error' = 'success') => (
    <StyledToastContainer>
        <div>{content}</div>
        <StyledCloseIcon $variant={variant} onClick={() => RHT.dismiss(id)} />
    </StyledToastContainer>
)

type Options = Partial<
    Pick<Toast, 'className' | 'id' | 'style' | 'icon' | 'duration' | 'ariaProps' | 'position' | 'iconTheme'>
>

export const toast = {
    success: (content: ReactNode, options?: Options) =>
        RHT.success(t => renderToast(content, t.id, 'success'), options),
    error: (content: ReactNode, options?: Options) => RHT.error(t => renderToast(content, t.id, 'error'), options)
}
